import { Checkbox, Flex, Text } from "@chakra-ui/react";
import { FormattedMessage, useIntl } from "react-intl";

import { ProjectUser } from "@nens/rana/api-v1";
import { RanaLoading, RanaModal } from "@nens/ranalib";
import { RanaErrors } from "@nens/ranalib";

import { useUpdateProjectUsers } from "../api/update-project-user";

interface ProjectUserRemoveModalProps {
  onClose: () => void;
  users: ProjectUser[];
}

export function ProjectUserRemoveModal({ onClose, users }: ProjectUserRemoveModalProps) {
  const intl = useIntl();
  const { isMutating, errors, mutate } = useUpdateProjectUsers(users, onClose);
  const removeUsers = () => mutate(null);

  return (
    <RanaModal
      isOpen
      onClose={onClose}
      topBar={
        <FormattedMessage id="header.remove_project_user" defaultMessage="Remove from project" />
      }
      maxW="xl"
      h="xs"
      buttons={[
        {
          children: intl.formatMessage({
            id: "button.maintain_access",
            defaultMessage: "Maintain access",
          }),
          variant: "secondary",
          isDisabled: isMutating,
          onClick: onClose,
        },
        {
          children: intl.formatMessage({
            id: "button.remove_project_user",
            defaultMessage: "Remove from project",
          }),
          variant: "danger",
          isDisabled: isMutating,
          onClick: removeUsers,
        },
      ]}
    >
      <Flex flexDir="column" gap={2}>
        <Text>
          <FormattedMessage
            id="paragraph.remove_project_user"
            defaultMessage="From the moment you delete the user account, the user no longer has access to project and the data related to it."
          />
        </Text>
        <Checkbox>
          <FormattedMessage
            id="checkbox.send_user_notification"
            defaultMessage="Send the user a notification about the removal of access"
          />
        </Checkbox>
        {isMutating && <RanaLoading size="md" isCentered />}
        <RanaErrors errors={errors} />
      </Flex>
    </RanaModal>
  );
}
